(ns minorodata.tables-metadata.subs
  (:require [minorodata.utils :refer [find-first]]
            [re-frame.core :as re-frame]
            [clojure.string :as str]))

(re-frame/reg-sub
 :tables-metadata.subs/table
 (fn []
   [(re-frame/subscribe [:tables-metadata/prop :tables-metadata/tables])])
 (fn [[tables] [_ {:keys [catalog schema table]}]]
   (let [name (str/upper-case (str catalog "." schema "." table))]
     (find-first #(= name (str/upper-case (:id %)))
                 tables))))
